export default __webpack_public_path__ + "static/greeting-cfdbeebb0b35b1e2d785f2ca471b5ea3.svg";